import initialState from './partnerSettingsInitialState';
import actions from './partnerSettingsAction';
import mutations from './partnerSettingsMutation';

const getters = {};

const partnerSettingsModule = {
  state: initialState(),
  mutations,
  actions,
  getters,
};

export default partnerSettingsModule;
